import { JudgingQuestion } from '../../../models';

export const noJudgingEmptyStateLabel = 'No in-tool human judging for country awards';

export const scoringReasoningAvailable = (judgingQuestions: JudgingQuestion[]): boolean => judgingQuestions.length > 0;
